import { render, staticRenderFns } from "./MerchantOrderView.vue?vue&type=template&id=20561134&"
import script from "./MerchantOrderView.vue?vue&type=script&lang=js&"
export * from "./MerchantOrderView.vue?vue&type=script&lang=js&"
import style0 from "./MerchantOrderView.vue?vue&type=style&index=0&id=20561134&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports